import SuiLoadingButton, {
    SuiLoadingButtonProps,
} from '@upheal/design-system/components/legacy/Sui/SuiLoadingButton';
import { useState } from 'react';
import { uiEventDataAttrs } from '../../../../utils/analytics/ui-tracking';

type PricingCardCTAProps = {
    title: string;
    uiLocation?: string;
    uiProperty?: string;
    onClick?: () => void | Promise<void>;
} & Omit<SuiLoadingButtonProps, 'onClick'>;

export const PricingCardCTA = (props: PricingCardCTAProps) => {
    const { title, uiLocation, uiProperty, onClick, ...rest } = props;
    const [loading, setLoading] = useState(false);

    const handleClick = () => {
        const maybePromise = onClick?.();

        if (maybePromise instanceof Promise) {
            setLoading(true);
            maybePromise.finally(() => setLoading(false));
        }
    };

    return (
        <SuiLoadingButton
            color="primary"
            size="small"
            onClick={handleClick}
            loading={loading}
            {...rest}
            {...uiEventDataAttrs(
                'Pricing Card Clicked',
                uiLocation,
                uiProperty,
            )}
        >
            {title}
        </SuiLoadingButton>
    );
};
